module.exports = __webpack_public_path__ + "img/image_biometric.45ecd0ba.jpg";